import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { defaultBrand } from '../constants/defaultBrand';
import { BrandContext } from '../contexts/BrandContext';

const BrandProvider = props => {
  const [brand, setBrand] = useState(defaultBrand);
  const [logo, setLogo] = useState('');

  const contextValue = useMemo(() => ({ brand, setBrand, logo, setLogo }), [brand, logo]);

  return <BrandContext.Provider value={contextValue}>{props.children}</BrandContext.Provider>;
};

BrandProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default BrandProvider;
